var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MainPage"},[(_vm.shouldShowHeader)?_c('TheHeader'):_vm._e(),_c('router-view',{key:_vm.$route.fullPath}),(_vm.shouldShowFooter)?_c('TheFooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }